
export const analytics = {
    trackAnalytics: (eventObject) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(eventObject);
    },
};
